<template>
  <b-container style="width:50%">
    <p>Please enter your Apoplectic user name below. You will be provided a one time code to validate your identity
      along with the opportunity to change your password before logging into Apoplectic.net.</p>
    <b-row>
      <b-col class="text-center">
        <b-alert variant="warning" :show="inError" style="display:inline-block;">
          {{ resetPasswordErrorMessage }}
        </b-alert>
      </b-col>
    </b-row>
    <b-form id="forgotPasswordForm" @submit="doSubmit">
      <b-form-group id="usernameGroup" label="User Name">
        <b-form-input id="userName" required v-model="form.userName"></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="outline-danger">Reset Password</b-button>
    </b-form>
  </b-container>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'ResetPasswordRequest',
    data () {
      return {
        inError: false,
        resetPasswordErrorMessage: '',
        form: {
          userName: ''
        }
      }
    },
    methods: {
      doSubmit (e) {
        e.preventDefault()
        this.inError = false
        Auth.forgotPassword(this.form.userName).then(() => {
          this.$emit('requestSubmitted', this.form.userName)
        }).catch(err => {
          this.resetPasswordErrorMessage = err.message
          this.inError = true
        })
      }
    }
  }
</script>
